import { IAppContextReducerAction } from '@interfaces/IAppContextReducerAction';
import { IConsentCookie } from '@interfaces/IConsentCookie';
import { IUser } from '@interfaces/IUser';

const appContextReducer = (state: IUser, action: IAppContextReducerAction): IUser => {
  switch (action.type) {
    case 'changeAuth':
      return {
        ...state,
        IsAuthenticated: !!action.value,
      };
    case 'changeLanguage':
      return {
        ...state,
        Language: action.value?.toString(),
      };
    case 'changeTheme':
      return {
        ...state,
        Theme: action.value?.toString(),
      };
    case 'changeConsent':
      return {
        ...state,
        ConsentCookie: action.value as IConsentCookie,
      };
    case 'changeFirstName':
      return {
        ...state,
        FirstName: action.value?.toString(),
      };
    case 'changeLastName':
      return {
        ...state,
        LastName: action.value?.toString(),
      };
    case 'changeNickName':
      return {
        ...state,
        NickName: action.value?.toString(),
      };
    case 'changeEmail':
      return {
        ...state,
        Email: action.value?.toString(),
      };
    case 'changeDrawer':
      return {
        ...state,
        Drawer: !!action.value,
      };
    case 'changeConfig':
      return {
        ...state,
        Config: !!action.value,
      };
    case 'changeValidated':
      return {
        ...state,
        Validated: !!action.value,
      };
    case 'changeOwner':
      return {
        ...state,
        Owner: !!action.value,
      };
    default:
      return state;
  }
};

export default appContextReducer;
